var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.771 511.771",
    height: 512,
    viewBox: "0 0 511.771 511.771",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "rgb(0,0,0)",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m218.116 271.21-163.45-88.83c-5.461-2.968-12.109.986-12.109 7.201v206.062c0 2.947 1.583 5.668 4.145 7.125l163.451 92.921c5.463 3.106 12.246-.84 12.246-7.125v-210.154c-.001-3.003-1.644-5.766-4.283-7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m435.131 108.323-178.238-92.403c-2.381-1.234-5.215-1.226-7.588.023l-175.611 92.404c-5.83 3.068-5.841 11.412-.018 14.495l175.611 92.979c2.383 1.262 5.234 1.27 7.625.023l178.239-92.979c5.881-3.068 5.87-11.488-.02-14.542z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m457.105 182.38-163.451 88.83c-2.639 1.434-4.282 4.197-4.282 7.201v210.153c0 6.285 6.782 10.23 12.245 7.125l163.451-92.921c2.562-1.457 4.145-4.177 4.145-7.125v-206.062c.001-6.215-6.647-10.169-12.108-7.201z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.067dfdba.svg";
export { ForwardRef as ReactComponent };